<template>
  <div class="main-content">
    <h2 class="m-b-sm">人才对比</h2>
    <div class="b-b"></div>
    <div class="row">
      <div class="col-xs-12 p-b-sm">
        <radar style="height:350px;" :title="radar_data.title" :legend="radar_data.legend" :series="radar_data.series" :indicator="radar_data.indicator"></radar>
      </div>
      <div class="col-xs-12">
        <table class="compare-table" border="1">
          <thead>
            <tr>
              <th colspan="2" style="width:150px;" class="yaxis">
                <div class="p-t-b-xs text-left lower strong">* 绿色表示低位数值</div>
                <div class="p-t-b-xs text-left higher strong">* 红色表示高位数值</div>
              </th>
              <th v-for="record in records" :key="record._id">
                <div class="p-t-b-xs text-left">姓名：{{record.evaluate_invitation.realname}}</div>
                <div class="p-t-b-xs text-left">手机：{{record.evaluate_invitation.phone}}</div>
                <div class="p-t-b-xs text-left">岗位：{{record._questionnaire.name}}</div>
                <div class="p-t-b-xs text-center">
                  <router-link :to="{'name':'EvaluateReport',params:{'code':record._id}}" tag="a" class="btn btn-xs btn-primary" target="_blank">详情</router-link>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td :colspan="2+records.length" class="table-title">测评概况</td>
            </tr>
            <tr>
              <td colspan="2" class="yaxis">综合得分</td>
              <td v-for="record in records" :key="record._id" :class="{'lower':record.abilities_score == preview.score.min,'higher':record.abilities_score == preview.score.max}">
                {{record.abilities_score.toFixed(2)}}
              </td>
            </tr>
            <tr>
              <td colspan="2" class="yaxis">答题时间(分)</td>
              <td v-for="record in records" :key="record._id" :class="{'lower':record.duration == preview.duration.min,'higher':record.duration == preview.duration.max}">
                {{(record.duration/60000).toFixed(2)}}
              </td>
            </tr>
            <tr>
              <td colspan="2" class="yaxis">求职人员排名</td>
              <td v-for="record in records" :key="record._id" :class="{'lower':record.ability_rate == preview.rate.min,'higher':record.ability_rate == preview.rate.max}">
                {{'领先'+(record.ability_rate*100).toFixed(2)+'%'}}
              </td>
            </tr>
            <tr>
              <td colspan="2" class="yaxis">入职员工排名</td>
              <td v-for="record in records" :key="record._id" :class="{'lower':record.entry_rate == preview.entry_rate.min,'higher':record.entry_rate == preview.entry_rate.max}">
                {{'领先'+((record.entry_rate||0)*100).toFixed(2)+'%'}}
              </td>
            </tr>
          </tbody>
          <tbody v-for="(ability,key) in abilities" :key="key" class="p-b-sm">
            <tr>
              <td :colspan="2+records.length" class="table-title">{{ability.name||'&nbsp;'}}</td>
            </tr>
            <tr>
              <td colspan="2" class="yaxis">得分</td>
              <td v-for="record in records" :key="record._id" :class="{'lower':record.abilities[key] &&record.abilities[key].score == ability.score.min,'higher':record.abilities[key] &&record.abilities[key].score == ability.score.max}">
                {{record.abilities[key]?record.abilities[key].score.toFixed(2):'-'}}
              </td>
            </tr>
            <tr>
              <td colspan="2" class="yaxis">求职人员排名</td>
              <td v-for="record in records" :key="record._id" :class="{'lower':record.abilities[key] &&record.abilities[key].rate == ability.rate.min,'higher':record.abilities[key] &&record.abilities[key].rate == ability.rate.max}">
                {{record.abilities[key]?`领先${(record.abilities[key].rate*100).toFixed(2)}%` :'-'}}
              </td>
            </tr>
            <template class="col-xs-12" v-for="(indicator,indicatorId) in ability.indicators">
              <tr :key="indicator._id">
                <td rowspan="3" class="yaxis">{{indicator.name||"&nbsp;"}}</td>
                <td>得分</td>
                <td v-for="record in records" :key="record._id" :class="{'lower':record.indicators[indicatorId] &&record.indicators[indicatorId].score == indicator.score.min,'higher':record.indicators[indicatorId] &&record.indicators[indicatorId].score == indicator.score.max}">
                  {{record.indicators[indicatorId]?record.indicators[indicatorId].score.toFixed(2):'-'}}
                </td>
              </tr>
              <tr :key="indicator._id">
                <td>耗时(分)</td>
                <td v-for="record in records" :key="record._id" :class="{'lower':record.indicators[indicatorId] &&record.indicators[indicatorId].duration == indicator.duration.min,'higher':record.indicators[indicatorId] &&record.indicators[indicatorId].duration == indicator.duration.max}">
                  {{record.indicators[indicatorId]?(record.indicators[indicatorId].duration/60000).toFixed(2) :'-'}}
                </td>
              </tr>
              <tr :key="indicator._id">
                <td>求职人员排名</td>
                <td v-for="record in records" :key="record._id" :class="{'lower':record.indicators[indicatorId] &&record.indicators[indicatorId].rate == indicator.rate.min,'higher':record.indicators[indicatorId] &&record.indicators[indicatorId].rate == indicator.rate.max}">
                  {{record.indicators[indicatorId]?`领先${(record.indicators[indicatorId].rate*100).toFixed(2)}%` :'-'}}
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Evaluate from "../../resource/evaluate";

import async from "async";
import Radar from "../blocks/radar.vue";

export default {
  name: "EvaluateCompare",
  data: function() {
    return {
      recordIds: [],
      records: [],
      abilities: {},
      indicators: {},
      evaluate: {},
      is_mounted: false,
      radar: null,
      preview: {
        score: {
          max: 0,
          min: Date.now()
        },
        duration: {
          max: 0,
          min: Date.now()
        },
        rate: {
          max: 0,
          min: Date.now()
        },
        entry_rate: {
          max: 0,
          min: Date.now()
        }
      },
      detail_data: 0,
      radar_data: {
        title: "",
        legend: [],
        series: [],
        indicator: []
      }
    };
  },
  components: { Radar },
  created: function() {
    // 页面渲染完成后
    const that = this;

    document.title = "简历对比";
  },
  mounted: function() {
    let that = this;
    that.$route.params.ids.split("-").forEach(recordId => {
      if (that.global.regex.id.test(recordId)) {
        that.recordIds.push(recordId);
      }
    });
    that.loadReports();
    that.is_mounted = true;
  },
  methods: {
    buildRadar: function() {
      let that = this;
      let indicator = [];
      let abilities = [];
      let series = [];
      let legend = [];
      for (let p in that.abilities) {
        abilities.push(p);
        indicator.push({
          name: that.abilities[p].name,
          max: 100
        });
      }
      // 设置数据
      that.records.forEach(record => {
        let serie = {
          name: record.evaluate_invitation.realname,
          type: "radar",
          tooltip: {
            trigger: "item"
          },
          data: [
            {
              value: [],
              name: record.evaluate_invitation.realname
            }
          ]
        };
        abilities.forEach(ability => {
          serie.data[0].value.push(
            record.abilities[ability]
              ? Number(record.abilities[ability].score.toFixed(2))
              : 0
          );
        });
        // 设置legend
        legend.push(record.evaluate_invitation.realname);
        series.push(serie);
      });
      that.radar_data.title = "得分对比";
      that.radar_data.legend = legend;
      that.radar_data.indicator = indicator;
      that.radar_data.series = series;
    },
    loadReports: function() {
      const that = this;
      // 跳转到控制台
      if (that.recordIds.length === 0) {
        return that.$router.replace("/company");
      }
      async.map(
        that.recordIds,
        (recordId, done) => {
          that.loadReport(recordId, (err, record) => {
            done(null, record);
          });
        },
        (err, records) => {
          let _records = [];
          let _abilities = {};
          let _indicators = {};
          records.forEach(record => {
            if (record) {
              that.preview.score.max =
                that.preview.score.max > record.abilities_score
                  ? that.preview.score.max
                  : record.abilities_score;
              that.preview.score.min =
                that.preview.score.min < record.abilities_score
                  ? that.preview.score.min
                  : record.abilities_score;
              that.preview.duration.max =
                that.preview.duration.max > record.duration
                  ? that.preview.duration.max
                  : record.duration;
              that.preview.duration.min =
                that.preview.duration.min < record.duration
                  ? that.preview.duration.min
                  : record.duration;

              that.preview.rate.max =
                that.preview.rate.max > record.ability_rate
                  ? that.preview.rate.max
                  : record.ability_rate;
              that.preview.rate.min =
                that.preview.rate.min < record.ability_rate
                  ? that.preview.rate.min
                  : record.ability_rate;
              that.preview.entry_rate.max =
                that.preview.entry_rate.max > record.entry_rate
                  ? that.preview.entry_rate.max
                  : record.entry_rate;
              that.preview.entry_rate.min =
                that.preview.entry_rate.min < record.entry_rate
                  ? that.preview.entry_rate.min
                  : record.entry_rate;
              let __abilities = {};
              record.abilities.forEach(ability => {
                let _abilityId = ability.ability._id; // 获取abilityId
                let tmp = _abilities[_abilityId]; // 获取缓存对象
                if (!tmp) {
                  tmp = {
                    name: ability.ability.name,
                    score: {
                      max: ability.score,
                      min: ability.score
                    },
                    duration: {
                      max: ability.duration,
                      min: ability.duration
                    },
                    rate: {
                      max: ability.rate,
                      min: ability.rate
                    },
                    indicators: {}
                  };
                  _abilities[_abilityId] = tmp;
                } else {
                  tmp.score.max =
                    tmp.score.max > ability.score
                      ? tmp.score.max
                      : ability.score;
                  tmp.score.min =
                    tmp.score.min < ability.score
                      ? tmp.score.min
                      : ability.score;

                  tmp.duration.max =
                    tmp.duration.max > ability.duration
                      ? tmp.duration.max
                      : ability.duration;
                  tmp.duration.min =
                    tmp.duration.min < ability.duration
                      ? tmp.duration.min
                      : ability.duration;

                  tmp.rate.max =
                    tmp.rate.max > ability.rate ? tmp.rate.max : ability.rate;
                  tmp.rate.min =
                    tmp.rate.min < ability.rate ? tmp.rate.min : ability.rate;
                }
                __abilities[_abilityId] = {
                  name: ability.ability.name,
                  score: ability.score,
                  rate: ability.rate
                };
                ability.indicators.forEach(indicator => {
                  let _indicatorId = indicator.indicator; // 获取indicatorId
                  let tmpIndicator = tmp.indicators[_indicatorId]; // 获取缓存对象
                  if (!tmpIndicator) {
                    tmpIndicator = {
                      _id: indicator.indicator,
                      name: "",
                      score: {
                        max: 0,
                        min: 10000
                      },
                      duration: {
                        max: 0,
                        min: Date.now()
                      },
                      rate: {
                        max: 0,
                        min: 10000
                      }
                    };
                    tmp.indicators[_indicatorId] = tmpIndicator;
                    _indicators[_indicatorId] = tmpIndicator; // 缓存用户后续关联
                  }
                });
              });
              record.abilities = __abilities; // 设置修改后的ability

              // 设置indicator
              let __indicators = {};
              record.indicators.forEach(indicator => {
                let tmpIndicator = _indicators[indicator.indicator._id];
                tmpIndicator.name = indicator.indicator.name;
                __indicators[indicator.indicator._id] = {
                  rate: indicator.rate,
                  score: indicator.score,
                  duration: indicator.duration
                };
                tmpIndicator.score.max =
                  tmpIndicator.score.max > indicator.score
                    ? tmpIndicator.score.max
                    : indicator.score;
                tmpIndicator.score.min =
                  tmpIndicator.score.min < indicator.score
                    ? tmpIndicator.score.min
                    : indicator.score;

                tmpIndicator.duration.max =
                  tmpIndicator.duration.max > indicator.duration
                    ? tmpIndicator.duration.max
                    : indicator.duration;
                tmpIndicator.duration.min =
                  tmpIndicator.duration.min < indicator.duration
                    ? tmpIndicator.duration.min
                    : indicator.duration;

                tmpIndicator.rate.max =
                  tmpIndicator.rate.max > indicator.rate
                    ? tmpIndicator.rate.max
                    : indicator.rate;
                tmpIndicator.rate.min =
                  tmpIndicator.rate.min < indicator.rate
                    ? tmpIndicator.rate.min
                    : indicator.rate;
              });

              record.indicators = __indicators; // 设置修改后的ability
              _records.push(record);
            }
          });
          that.abilities = _abilities; // 全局的abilities
          that.indicators = _indicators; // 全局的indicators
          that.records = _records;
          that.buildRadar();
        }
      );
    },
    loadReport: function(code, cb) {
      let that = this;
      that.$http.get(`/api/v1/evaluate/${code}/compare`).then(
        res => {
          let data = res.body;
          if (data.code === 0) {
            cb(null, data.result);
          } else {
            cb(data);
          }
        },
        res => {
          cb({ code: res.code });
        }
      );
    }
  },
  destroyed: function() {
    let that = this;
    if (that.radar) {
      that.radar.dispose();
      that.radar = null;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
#radar-area {
  height: 300px;
}
.compare-table {
  width: 100%;
  tr {
    td {
      font-size: 15px;
      padding: 8px 15px;
      text-align: left;
    }
    th {
      font-size: 15px;
      padding: 8px 15px;
    }
    &:nth-child(even) {
      background-color: rgba(224, 224, 224, 0.4);
    }
    &:hover {
      background-color: rgba(204, 204, 204, 0.6);
    }
  }
  table-layout: fixed;
  thead {
    border: 1px solid #ccc;
    th {
      font-weight: 400 !important;
    }
  }
  tbody {
    border: 1px solid #ccc;
    .table-title {
      padding: 15px 8px !important;
    }
    .yaxis {
      text-align: center !important;
    }
  }
  .lower {
    color: green;
  }
  .higher {
    color: red;
  }
}
</style>



// WEBPACK FOOTER //
// compare.vue?f0df5548